/**
 * @author    Agence Dn'D <contact@dnd.fr>
 * @copyright 2004-present Agence Dn'D
 * @license   https://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * @link      https://www.dnd.fr/
 */

function checkId() {
    let klaviyoId = null;
    const lang =  document.documentElement.lang;

    if (window.innerWidth >=768 ) {
        if (lang === 'fr') {
            klaviyoId = "WYY4iu";
        }

        if (lang === 'en') {
            klaviyoId = "RWdraB";
        }

    } else {
        if (lang === 'fr') {
            klaviyoId = "UWEpKP";
        }

        if (lang === 'en') {
            klaviyoId = "SrYXeX";
        }
    }

    return klaviyoId;
}

window.openKlPopin = function openKlPopin(){
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", checkId()]);
}